import {
  DashboardOutlined,
  DesktopOutlined,
  FileOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PayCircleOutlined,
  PieChartOutlined, PoweroffOutlined, ShopOutlined, ShoppingCartOutlined, StepBackwardOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { MainLayoutProps } from "../models/main_layout_props";
import { logoutUserRequest } from "../store/slices/user-slice";
import { AppDispatch } from "../store/types/store";
import { Confirm } from "./Confirm";
import { useNavigate } from "react-router-dom";

const { Sider } = Layout;

interface SideBarType {
    collapsed: boolean,
    setCollapsed: (collapsed: boolean) => void,
    handleLogout: () => void
}

const SideBar = ({ collapsed, setCollapsed, handleLogout }: SideBarType) => {

  const navigate = useNavigate();

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      trigger={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
    >
      <a href="/" className="sidebar-logo-wrapper">
        {/* Replace with your logo */}
        <img
          src={require("../assets/images/symmatics-logo-white.png")} // Path to your logo image
          alt="Logo"
        />
        {!collapsed && <p>Symmatics Core</p>}
      </a>
      <Menu theme="dark" defaultSelectedKeys={["1"]} mode="inline">
        <Menu.Item key="1" icon={<DashboardOutlined />} onClick={() => navigate('/')}>
          Dashboard
        </Menu.Item>
        <Menu.SubMenu key="sub1" icon={<ShoppingCartOutlined />} title="Purchases">
          <Menu.Item key="4" onClick={() => navigate('/payments/requests')}>Payment Tokens</Menu.Item>
          <Menu.Item key="3" onClick={() => navigate('/payments/list')}>Payments</Menu.Item>
        </Menu.SubMenu>
        <Menu.Item
          key="10"
          icon={<PoweroffOutlined />}
          onClick={handleLogout}
          style={{ marginTop: "auto" }} // Ensure the logout button stays at the bottom
        >
          Logout
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export { SideBar };
